angular.module('impactx.dashboard').controller('DashboardUserCtrl', ['$scope', 'dataGen', '$context', DashboardUserCtrl]);

function DashboardUserCtrl($scope, dataGen, $context) {
    $context.refreshUser($scope, dataGen, $context);
}